import { OverviewQuestionnaireItem } from './subsections/overview/questionnaire'

// Main section marker
export enum ResumptionOverviewSectionQuestionnaireItem {
  RESUMPTION_OVERVIEW = 'resumption-overview',
  RESUMPTION_OVERVIEW_NOTES = 'resumption-overview/notes'
}

// Amalgamate all subsection questionnaire enums
export const ResumptionOverviewQuestionnaireItem = {
  ...ResumptionOverviewSectionQuestionnaireItem,
  ...OverviewQuestionnaireItem
} as const

export type ResumptionOverviewQuestionnaireItem =
  (typeof ResumptionOverviewQuestionnaireItem)[keyof typeof ResumptionOverviewQuestionnaireItem]
